import script from "./form-question-field.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-question-field.vue?vue&type=script&lang=ts&setup=true"

import "./form-question-field.vue?vue&type=style&index=0&id=573d6b92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573d6b92"]])

export default __exports__